<template>
  <div>
    <SmartTitle heading="1" weight="medium">Tradutor DB</SmartTitle>
    <div class="flex align-center my-4 justify-between">
      <form class="spacing-input-search">
        <div class="flex justify-end">
          <v-text-field
            v-model="search"
            label="Pesquisar"
            single-line
            hide-details
          />
          <div
            @click="searchByName($event.type)"
            class="flex my-1 align-center justify-center cursor-pointer rounded absolute bg-brand-translate"
            style="width: 40px; height: 40px"
          >
            <SmartIcon
              :size="2"
              name="search"
              color="#77bd4f"
            />
          </div>
        </div>
      </form>
      <div>
        <SmartDrawer @close="() => {showCreateDB = false; }" :show="showCreateDB">
          <template v-slot:header>
            <SmartTitle class="text-brand-secondary" weight="regular">Atribuir</SmartTitle>
          </template>
          <CreateTradutor @close="closeCreateDrawer"/>
        </SmartDrawer>
        <SmartButton class="mt-4" @click="showCreateDB = true">
          Atribuir
        </SmartButton>
      </div>
    </div>
    <FilterTradutor @filter="filters"/>
    <div v-if="!loading">
      <div>
        <SmartRow class="mx-0 justify-space-between mt-5 mb-2">
          <SmartTitle
            weight="medium"
            class="mb-2 ml-1 py-2"
          >Distribuidores Atribuidos</SmartTitle>
          <SmartButton
            secondary
            weight= "300px"
            :loading="loading"
            @click="exportarDePara">
            <SmartIcon name="export" :size="1"/>Exportar Agora
          </SmartButton>
        </SmartRow>
      </div>
      <SmartModal
        v-if="modal"
        v-bind="modal"
        @close.prevent="modal = null"
        @return="typeModalReturn()"
      >
        {{ modal.text }}
      </SmartModal>
      <VDataTable
        :headers="headers"
        :items="dbTradutor"
        hide-actions
        no-data-text="Nenhum dado a ser exibido"
        class="my-4"
        :must-sort="true"
        @update:pagination="sort"
        :class="{'loading': false }"
      >
        <template slot="items" slot-scope="props">
          <td class="font-size-default force-text-black limited-info-style name-width">{{props.item.nome_para}}</td>
          <td width="144">{{props.item.nome_padrao}}</td>
          <td>{{props.item.codigo}}</td>
          <td class="view-icon" width="100">
            <label
              @click="showInfo(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="edit" class="mr-1-2" />
            </label>
          </td>
          <td class="view-icon" width="100">
            <label
              @click="deleteTradutorDB(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="trash" class="mr-1-2" />
            </label>
          </td>
        </template>
      </VDataTable>
      <div>
        <SmartDrawer @close="() => {showDrawer = false; edit = null}" :show="showDrawer">
          <template v-slot:header>
            <SmartTitle class="text-brand-secondary" weight="regular">Editar</SmartTitle>
          </template>
          <EditTradutor v-if="edit" :edit="edit" @close="closeEditDrawer"/>
        </SmartDrawer>
      </div>
      <div class="flex justify-center">
        <v-pagination
          v-if="currentPage"
          v-model="pagination.page"
          @input="changePage"
          :length="length"
          :value="currentPage"
          :total-visible="7"
          circle
        />
      </div>
    </div>

    <div v-if="!loading">
      <div>
        <SmartRow class="mx-0 justify-space-between mt-5 mb-2">
          <SmartTitle
            weight="medium"
            class="mb-2 ml-1 py-2"
          >Distribuidores Não Atribuidos</SmartTitle>
        </SmartRow>
      </div>
      <VDataTable
        :headers="unassignedDistributors"
        :items="dbNotAssigned"
        hide-actions
        no-data-text="Nenhum dado a ser exibido"
        class="my-4"
        :must-sort="true"
        @update:pagination="sort"
        :class="{'loading': false }"
      >
        <template slot="items" slot-scope="props">
          <td class="font-size-default force-text-black limited-info-style name-width">{{props.item.distribuidor}}</td>
          <td class="view-icon" width="100">
            <label
              @click="assignDistributor(props.item.distribuidor)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="plus" class="mr-1-2" />
            </label>
          </td>
        </template>
      </VDataTable>
      <div>
        <SmartDrawer @close="() => {showAssignDB = false; attribute = null}" :show="showAssignDB">
          <template v-slot:header>
            <SmartTitle class="text-brand-secondary" weight="regular">Atribuir</SmartTitle>
          </template>
          <AssignTradutor v-if="attribute" :attribute="attribute" @close="closeAssignDrawer"/>
        </SmartDrawer>
      </div>
      <div class="flex justify-center">
        <v-pagination
          v-if="currentPageNotAssigned"
          v-model="paginationNotAssigned.page"
          @input="changePageNotAssigned"
          :length="lengthNotAssigned"
          :value="currentPageNotAssigned"
          :total-visible="7"
          circle
        />
      </div>
    </div>
    <SmartCard class="mt-1 p-3" v-else>
      <SmartSkeletonLoading :items="11" :height="4" />
    </SmartCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import { downloadCsvFile } from 'utils/blob';
import moment from 'moment';

export default {
  name: 'TradutorDB',
  components: {
    EditTradutor: () => import('./EditTradutorDB'),
    CreateTradutor: () => import('./CreateTradutorDB'),
    AssignTradutor: () => import('./AssignTradutorDB'),
    FilterTradutor: () => import('./FilterTradutorDB')
  },
  mixins: [clickaway],
  data() {
    return {
      loading: false,
      loadingExclude: false,
      filterModal: false,
      edit: null,
      attribute: null,
      modal: null,
      search: null,
      searchByMethod: '',
      showDrawer: false,
      showCreateDB: false,
      showAssignDB: false,
      length: null,
      lengthNotAssigned: null,
      id: null,
      type: null,
      event: null,
      resultFilter: {},
      nicknames: '',
      distribuidor: '',
      currentPage: 1,
      currentPageNotAssigned: 1,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      paginationNotAssigned: {
        rowsPerPage: 10,
        page: 1
      },
      headers: [
        { text: 'De (Nome)', value: 'name', sortable: true },
        { text: 'Para (Distribuidor)', value: 'distribuidor', sortable: true },
        { text: 'Código', value: 'codigo', sortable: true },
        { text: 'Editar', value: 'editar', sortable: true },
        { text: 'Excluir', value: 'excluir', sortable: true }
      ],
      unassignedDistributors: [
        { text: 'De (Nome)', value: 'name', sortable: true },
        { text: 'Atribuir', value: 'editar', sortable: true }
      ],

      currentSort: {
        order: 'asc',
        sort: 'name'
      }
    };
  },
  watch: {
    tradutorDBPagination(item) {
      if (item && item.current_page) {
        this.pagination.page = Number(item.current_page);
        this.length = item.last_page;
      }
    },
    tradutorDBPaginationNotAssigned(item) {
      if (item && item.current_page) {
        this.pagination.page = Number(item.current_page);
        this.lengthNotAssigned = item.last_page;
      }
    },
    async search(item) {
      if (!item) {
        this.loading = true;
        await this.fetchDeParaFiltro({ page: 1 });
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      listDB: 'tradutorDePara/listTradutorDePara',
      listDBNotAssigned: 'tradutorDePara/listTradutorDeParaNotAssigned',
      tradutorDBPagination: 'tradutorDePara/pagination',
      tradutorDBPaginationNotAssigned: 'tradutorDePara/paginationNotAssigned'
    }),
    dbTradutor() {
      const resultlist = this.listDB.map(dblist => ({
        id: dblist.id,
        id_origem_nome_db: dblist.id_origem_nome_db,
        id_db: dblist.id_db,
        nome_padrao: dblist.nome_padrao,
        nome_para: dblist.nome_para,
        codigo: dblist.codigo,
        cnpj: dblist.cnpj,
        created_at: dblist.created_at,
        updated_at: dblist.updated_at,
        deleted_at: dblist.deleted_at
      }));
      return ((this.listDB && resultlist) || []);
    },
    dbNotAssigned() {
      const resultListNotAssigned = this.listDBNotAssigned.map(dbListNotAssigned => ({
        distribuidor: dbListNotAssigned.distributor
      }));
      return ((this.listDBNotAssigned && resultListNotAssigned) || []);
    }

  },

  methods: {
    ...mapActions({
      fetchDePara: 'tradutorDePara/fetchDePara',
      fetchDeParaNotAssigned: 'tradutorDePara/fetchDeParaNotAssigned',
      exclude: 'tradutorDePara/exclude',
      fetchExportDePara: 'exportTradutorDePara/fetchExportDePara',
      fetchDeParaFiltro: 'tradutorDePara/fetchDeParaFiltro'
    }),
    typeModalReturn() {
      if (this.type === 'export') {
        this.tryExportFile();
      }
      if (this.type === 'delete') {
        this.deleteDB();
      }
    },
    exportarDePara() {
      this.resultFilter = {
        nicknames: this.nicknames,
        distributors: this.distribuidor
      };
      this.type = 'export';
      this.showConfirmModal();
    },
    tryExportFile() {
      this.showLoadModal();
      this.fetchExportDePara(this.resultFilter)
        .then(({ data }) => {
          const currentDate = moment().format('MMMM Do YYYY, h:mm:ss a');
          downloadCsvFile({ filename: currentDate, file: data });
          this.showSucessModal();
        })
        .catch(() => {
          this.showErrorModal();
        });
    },
    showLoadModal() {
      this.modal = {
        type: 'default',
        title: 'Carregando Arquivo...',
        icon: 'smooth',
        text: 'Estamos exportando o arquivo, aguarde um instante...'
      };
    },
    showSucessModal() {
      this.modal = {
        type: 'success',
        title: 'Exportação concluída com sucesso!',
        icon: 'accepted',
        buttonText: 'Ok, Continuar',
        text: 'Parabéns, sua exportação foi concluída.'
      };
    },
    showConfirmModal() {
      this.modal = {
        type: 'warning',
        title: 'Exportar Tabela',
        icon: 'alert',
        buttonText: 'Não, cancelar',
        secondButton: 'Sim, Exportar',
        text: 'Você realmente deseja exportar esta tabela?'
      };
    },
    showErrorModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops!',
        icon: 'alert',
        buttonText: 'Cancelar',
        text: 'Algo inesperado aconteceu ao exportar o arquivo, tente novamente.'
      };
    },
    showDeleteModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops! Vamos com calma...',
        icon: 'alert',
        buttonText: 'Cancelar',
        secondButton: 'Ok, excluir',
        text: 'Deseja realmente excluir este item?'
      };
    },
    async changePage(page) {
      if (this.toBeFind && this.event) {
        this.loading = true;
        await this.fetchDePara({ page, search: this.toBeFind }).then(() => {
          this.loading = false;
        });
      } else {
        this.event = null;
        this.loading = true;
        await this.fetchDePara({ page }).then(() => {
          this.loading = false;
        });
      }
    },
    async changePageNotAssigned(page) {
      if (this.toBeFind && this.event) {
        this.loading = true;
        await this.fetchDeParaNotAssigned({ page, search: this.toBeFind }).then(() => {
          this.loading = false;
        });
      } else {
        this.event = null;
        this.loading = true;
        await this.fetchDeParaNotAssigned({ page }).then(() => {
          this.loading = false;
        });
      }
    },
    awayFilter() {
      this.filterModal = false;
    },
    close() {
      this.filterModal = false;
    },
    showInfo(id) {
      const resultEdit = this.listDB.find(listTradutorDePara => listTradutorDePara.id === id);
      this.edit = {
        id: resultEdit.id,
        name: resultEdit.nome_para,
        dbName: resultEdit.nome_padrao,
        dbID: resultEdit.id_db
      };
      this.showDrawer = true;
    },
    assignDistributor(name) {
      const assign = this.listDBNotAssigned.find(listTradutorDeParaNotAssigned => listTradutorDeParaNotAssigned.distributor === name);
      this.attribute = {
        name: assign.distributor
      };
      this.showAssignDB = true;
    },
    deleteTradutorDB(id) {
      this.id = id;
      this.type = 'delete';
      this.showDeleteModal();
    },
    async deleteDB() {
      await this.exclude(this.id);
      this.fetchDePara({});
      this.fetchDeParaNotAssigned({});
      this.modal = null;
      this.id = null;
    },
    async searchByName(event) {
      this.event = event;
      const search = this.search.replace(/[.-]/g, '').trim();
      this.toBeFind = search;
      this.loading = true;

      await this.fetchDeParaFiltro({ search });

      this.loading = false;
    },
    async sort(sortable) {
      const newSort = {
        order: sortable.descending ? 'desc' : 'asc',
        sort: sortable.sortBy
      };
      if (JSON.stringify(newSort) !== JSON.stringify(this.currentSort)) {
        this.currentSort = newSort;
        this.fetchUsers({ page: this.pagination.page, search: this.search, sort: this.currentSort });
      }
    },
    closeCreateDrawer() {
      this.showCreateDB = false;
      this.fetchDePara();
    },
    closeAssignDrawer() {
      this.showAssignDB = false;
      this.fetchDeParaNotAssigned();
      this.fetchDePara();
    },
    closeEditDrawer() {
      this.showDrawer = false;
      this.fetchDePara();
    },
    filters(payload) {
      this.nicknames = payload.dePara;
      this.distribuidor = payload.distributor;
    }
  },
  async mounted() {
    this.loading = true;
    await this.fetchDePara({});
    await this.fetchDeParaNotAssigned({});
    this.length = this.tradutorDBPagination.last_page;
    this.lengthNotAssigned = this.tradutorDBPaginationNotAssigned.last_page;
    this.loading = false;
  }
};
</script>

<style scoped>
</style>


<style lang="scss">
.view-width {
  max-width: 100px;
}
.name-width {
  max-width: 300px;
}
table td,
table th {
  padding: 10px !important;
}
</style>
